module.exports = __webpack_public_path__ + "img/238.4d4602df.jpg";